import script from "./BoringTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BoringTable.vue?vue&type=script&setup=true&lang=js"

import "./BoringTable.vue?vue&type=style&index=0&id=b24b861a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/vue-data-provider/vue-data-provider/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b24b861a"]])

export default __exports__